<template>
  <div>
    <v-container fill-height fluid>
    <v-row>
      <v-flex xs3 class="mr-2">
        <Search
          v-model="filters.search"
          :label="$t('SEARCH')"
          prepend-icon="search"
          :delay="500"
        />
      </v-flex>
      <v-spacer></v-spacer>
    </v-row>
    </v-container>
    <v-data-table
      :headers="headers"
      :items="items"
      :server-items-length="totalItems"
      :no-data-text="$t('NO_DATA')"
      :no-results-text="$t('NO_DATA')"
      hide-default-footer
      :options.sync="pagination"
      :loading="loading"
      class="elevation-1"
    >
    </v-data-table>
    <div class="text-xs-center pt-2">
        <Paginator
          :total-items="totalItems"
          :page.sync="pagination.page"
          :items-per-page.sync="pagination.itemsPerPage"
          @change="fetchPermissions"
        />
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';

  import { permissionsService } from '../../../utils/services/permissions.service';
  import Search from '../../shared/Inputs/Search';
  import Paginator from '../../shared/Paginator';

  export default {
    name: 'UserPermissions',
    components: { Search, Paginator },
    props: {
      user: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
          loading: false,
          items: [],
          totalItems: 0,
          pagination: {
            page: 1,
            itemsPerPage: 10,
            sortDesc: [false],
            sortBy: ['name'],
          },
          headers: [
            {
              text: this.$t('fields.id'),
              align: 'left',
              value: 'id',
            },
            { text: this.$t('fields.name'), value: 'name' },
          ],
          filters: {
            search: null,
          },
      };
    },
    methods: {
      ...mapActions('confirm', ['showConfirm']),
      ...mapActions('alert', ['showToast']),
      async fetchPermissions(forcePage) {
        this.loading = true;
        const { page, itemsPerPage } = this.pagination;
        return permissionsService.index({
          page: page || forcePage || 1,
          itemsPerPage,
        })
        .then(response => {
            this.items = response.data.data;
            this.totalItems = response.data.meta.total;
            this.pagination = this.getPagination(
              response.data.meta,
              { oldPagination: this.pagination, forcePage },
            );
          })
          .catch(error => {
            this.handleError(error, this.errors);
          })
          .finally(() => {
            this.loading = false;
          });
      },
    },
    async created() {
      await this.fetchPermissions();
    },
  };
</script>
